<template>
  <div class="add">
    <avue-form :option="option" ref="form" v-model="form">
      <!-- <template slot="menuForm">
       
      </template> -->
      <template slot="companyPositionId">
        <div class="blocks">
          <div
            class="block"
            :class="form.companyPositionId == item.id ? 'active' : ''"
            v-for="(item, i) in roles"
            :key="i"
            @click="changePosition(item.id, item.v2SystemMenuId, i)"
          >
            <div class="label">
              <i class="el-icon-user-solid" color="#35b1ff"></i
              >{{ item.positionName }}
            </div>
            <div class="desc">{{item.positionDesc}}</div>
          </div>
        </div>
      </template>
      <template slot="qx"> </template>
    </avue-form>
    <div class="qx" v-show="form && form.companyPositionId">
      <el-card shadow="never" class="first">
        <el-tree
          disabled
          ref="tree"
          :default-expanded-keys="expandKeys"
          :data="menuData"
          show-checkbox
          node-key="id"
          :default-checked-keys="selectIds"
          :props="{
            children: 'children',
            label: 'name',
          }"
        >
        </el-tree>
      </el-card>
      <el-card shadow="never" class="second">
        <el-tree
          disabled
          :default-expanded-keys="appexpandKeys"
          ref="tree"
          :data="appMenuData"
          show-checkbox
          node-key="id"
          :default-checked-keys="selectIds"
          :props="{
            children: 'children',
            label: 'name',
          }"
        >
        </el-tree>
      </el-card>
    </div>
    <div class="btns">
      <el-button @click="cancelModal">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import { isMobileNumber } from "@/util/validate";
import { getRoles, addObj,putObj } from "@/api/chain/companystaff";
import { systemmenu } from "@/api/chain/companyposition";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {},
    roles: {
      type: Array,
    },
    menus: {
      type: Array,
    },
  },
  data() {
    return {
      selectIndex: 0,
      selectId: "",
      selectIds: [],
      // roles: [],,
      option: {
        emptyBtn: false,
        submitBtn: false,
        submitText: "保存",
        labelWidth: 120,
        labelPosition: "left",

        group: [
          {
            label: "基本信息",
            arrow: false,
            prop: "group1",
            column: [
              {
                prepend: "+86",
                label: "捷运途账号",
                prop: "mobile",
                sortable: true,
                search: true,
                maxlength: 11,
                placeholder: "请输入11位手机号码",
                // editDisabled: false,
                number: true,
                span: 24,
                rules: [
                  {
                    required: true,
                    message: "请输入11位手机号码",
                    trigger: "blur",
                  },
                  {
                    validator: isMobileNumber,
                    trigger: "blur",
                  },
                ],
                minWidth: 110,
                overHidden: true,
              },
              {
                label: "员工姓名",
                placeholder: "请输入名称，建议20字以内",
                showWordLimit:true,
                prop: "name",
                sortable: true,
                search: true,
                maxlength: 20,
                // editDisabled: false,
                rules: [
                  {
                    required: true,
                    message: "请输入姓名",
                    trigger: "blur",
                  },
                  {
                    max: 50,
                    message: "请输入名称，建议20字以内",
                  },
                ],
                overHidden: true,
              },

              //   {
              //     label: "角色",
              //     prop: "companyPositionId",
              //     sortable: true,
              //     type: "select",
              //     props: {
              //       label: "positionName",
              //       value: "id",
              //     },
              //     dicUrl: "/chain/companyposition/list",
              //     search: true,
              //     rules: [
              //       {
              //         required: true,
              //         message: "请选择职位",
              //         trigger: "blur",
              //       },
              //     ],
              //     formatter: (val) => {
              //       return val.positionName;
              //     },
              //     overHidden: true,
              //   },
              // {
              //   label: "所在部门",
              //   prop: "companyDeptId",
              //   sortable: true,
              //   type: "tree",
              //   search: true,
              //   searchOrder:1,
              //   order:2,
              //   props: {
              //     label: "deptName",
              //     value: "id",
              //   },
              //   defaultExpandAll: true,
              //   dicUrl: "/chain/companydept/tree",
              //   rules: [
              //     {
              //       required: true,
              //       message: "请选择所在部门",
              //       trigger: "blur",
              //     },
              //   ],
              //   width:160,
              //   overHidden:true,
              // },
              {
                label: "性别",
                prop: "sex",
                sortable: true,
                hide: true,
                type: "radio",
                span: 24,
                dicData: [
                  {
                    label: "男性",
                    value: "1",
                  },
                  {
                    label: "女性",
                    value: "0",
                  },
                ],
                rules: [
                  {
                    required: true,
                    message: "请选择性别",
                    trigger: "blur",
                  },
                ],
                overHidden: true,
              },

              {
                label: "状态",
                prop: "status",
                sortable: true,
                type: "radio", // 下拉选择
                search: true,
                dicData: [
                  {
                    label: "启用",
                    value: "1",
                  },
                  {
                    label: "停用",
                    value: "0",
                  },
                ],
                value: "1",
                searchIndex: 0,
                // selectIndex:0,
                // cascaderIndex:0,   //默认选择第几项
                rules: [
                  {
                    required: true,
                    message: "请选择状态",
                    trigger: "blur",
                  },
                  {
                    max: 1,
                    message: "长度在不能超过1个字符",
                  },
                ],
                overHidden: true,
              },
            ],
          },
          {
            label: "角色管理",
            arrow: false,
            prop: "group2",
            column: [
              {
                label: "",
                prop: "companyPositionId",
                span: 24,
                rules: [
                  {
                    required: true,
                    message: "请选择角色",
                    trigger: "blur",
                  },
                ],
              },
            ],
          },
          {
            label: "权限设置",
            arrow: false,
            display: true,
            prop: "group3",
          },
        ],
      },
      form: {},
    };
  },
  computed: {
    appMenuData() {
      return this.menus.filter((v) => {
        if (v.id == "1603324664323829761") {
          v.name = "APP移动端";
          return v;
        }
      });
    },
    menuData() {
      return [
        {
          name: "企业PC端",
          children: this.menus.filter((v) => v.id != "1603324664323829761"),
          disabled: true,
          id: 1,
        },
      ];
    },
    appexpandKeys() {
      return this.appMenuData.map((v) => v.id);
    },
    expandKeys() {
      return this.menuData.map((v) => v.id);
    },
  },
  mounted() {
    // this.getRoles();
    console.info(this.$refs.form);
    this.form = this.info;
    if (this.info.companyPositionId) {
      this.roles.map((v) => {
        if (v.id == this.info.companyPositionId) {
          this.changePosition(this.info.companyPositionId, v.v2SystemMenuId);
        }
      });
    } else {
      this.option.group[2].display = false;
    }
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done, loading) {
      this.$refs.form.validate((valid, done, msg) => {
        if (valid) {
          if (this.info.companyPositionId) {
            putObj(this.form)
            .then((response) => {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              this.$emit('saveSuccess')
            })
            .catch(() => {
              done();
            });
          }else{
            addObj(this.form)
            .then((response) => {
              this.$message({
                showClose: true,
                message: "添加plTableBox成功",
                type: "success",
              });
              this.$emit('saveSuccess')
            })
            .catch(() => {
              done();
            });
          }
          
        }
      });
    },
    addDisabledAttribute(array) {
      array.forEach((item) => {
        item.disabled = true; // 添加 disabled 属性
        if (item.children && Array.isArray(item.children)) {
          this.addDisabledAttribute(item.children); // 递归处理子数组
        }
      });
    },
    changePosition(id, ids, index) {
      this.option.group[2].display = true;
      this.form.companyPositionId = id;
      // this.selectIndex = index;
      this.selectIds = ids ? ids.split(",") : [];
      this.$refs.tree.setCheckedNodes(this.selectIds);
      console.info(this.selectIds);
      // this.setPerm();
    },
    getRoles() {
      getRoles().then((res) => {
        this.$nextTick(() => {
          this.roles = res.data.data;
          this.$forceUpdate();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  text-align: center;
  border-top: 1px solid #ededf0;
  padding-top: 8px;
}
/deep/.qx {
  margin-left: 100px;
  display: flex;
  .el-card {
    border: 1px solid #ededf0;
    border-bottom: none;
  }
  // /.el-tree-node.is-expanded>.el-tree-node__children {
  //   display: flex;
  //   flex-direction: column;
  //   height: 360px;
  //   flex-wrap: wrap;
  // }
  .first {
    width: 30%;
    border-right: none!important;;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
   .el-card{
   
  }
  .second {
    width: 70%;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
.add {
  margin-top: 20px;
}
/deep/.el-form-item__label {
  &::after {
    content: "*";
    color: #e60026;
    margin-left: 4px;
    font-size: 14px;
  }
  &::before {
    content: "" !important;
  }
}
/deep/.el-input {
  width: 440px;
  .el-input-group__prepend {
    width: 68px;
    height: 30px;
    text-align: center;
  }
  .el-input-group__append {
    background: #fff;
  }
}
/deep/.name {
  .el-input {
    .el-input__inner {
      border-right: none !important;
    }
  }
}
/deep/.avue-group__header {
  border: none;
  margin-bottom: 20px;
  height: 20px;
  line-height: 20px;
}
/deep/.avue-radio .el-radio {
  margin-right: 32px;
}
/deep/.avue-group__title {
  border-left: 2px solid #35b1ff;
}

.blocks {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .block {
    margin-bottom: 20px;
    margin-right: 20px;
    padding-left: 24px;
    padding-top: 28px;
    width: 350px;
    height: 160px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #eeeeee;
    font-weight: 500;
    font-size: 14px;
    color: #313133;
    .label {
      font-weight: 500;
      font-size: 14px;
      color: #313133;
      i {
        color: #35b1ff;
        margin-right: 10px;
      }
    }
    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-left: 24px;
    }
    &.active {
      border-color: #35b1ff;
    }
  }
}
</style>